// extracted by mini-css-extract-plugin
export default {"widget":"widget--1GOng","glossaryLink":"glossaryLink--9FZkM"};